export enum BfxDialogCommand {
  // Close/Kill all dialogs
  DIALOG_KILL_ALL,
  DIALOG_CLOSE, // closes any dialog regardless of the type
  DIALOG_CLOSE_INTERNAL, // notifiy that external dialog has closed, and cleanup references

  // Order -  Quick Fill Confirm
  DIALOG_ORDER_QUICK_FILL_CONFIRM_OPEN,
  DIALOG_ORDER_QUICK_FILL_CONFIRM_CLOSE,
  // Order - Quick Fill Warning
  DIALOG_ORDER_QUICK_FILL_WARNING_OPEN,
  DIALOG_ORDER_QUICK_FILL_WARNING_CLOSE,

  // Order -  Detail Fill Confirm
  DIALOG_ORDER_DETAIL_FILL_CONFIRM_OPEN,
  DIALOG_ORDER_DETAIL_FILL_CONFIRM_CLOSE,
  // Order - Quick Fill Warning
  DIALOG_ORDER_DETAIL_FILL_WARNING_OPEN,
  DIALOG_ORDER_DETAIL_FILL_WARNING_CLOSE,

  // Fill Tolerance warning
  DIALOG_ORDER_FILL_TOLERANCE_WARNING_OPEN,
  DIALOG_ORDER_FILL_TOLERANCE_WARNING_CLOSE,

  // Order - Cancel count breach
  DIALOG_ORDER_CANCEL_WARNING_OPEN,
  DIALOG_ORDER_CANCEL_WARNING_CLOSE,
  DIALOG_ORDER_CANCEL_CONFIRM_OPEN,
  DIALOG_ORDER_CANCEL_CONFIRM_CLOSE,
  // Order - Force Accept
  DIALOG_ORDER_ACCEPT_FORCE_WARING,
  DIALOG_ORDER_REJECT_FORCE_WARING,

  // Order - Accept Into
  DIALOG_ORDER_ACCEPT_INTO_OPEN,
  DIALOG_ORDER_ACCEPT_INTO_CLOSE,
  // MULTI - Export to CSV
  DIALOG_CSV_EXPORT_OPEN,
  DIALOG_CSV_EXPORT_CLOSE,
  // TRADE - Confirm Cancel Trade
  DIALOG_TRADE_CANCEL_CONFIRM_OPEN,
  DIALOG_TRADE_CANCEL_CONFIRM_CLOSE,
  // TRADE - Add Fill Comment
  DIALOG_TRADE_ADD_FILL_COMMENT_OPEN,
  DIALOG_TRADE_ADD_FILL_COMMENT_CLOSE,
  // FIND - Add Favorite
  DIALOG_FIND_NEW_FAVORITE,
  //FILTER - Copy Filter
  DIALOG_FILTER_COPY_OPEN,
  DIALOG_FILTER_COPY_CLOSE,
  //FILTER - Copy Filter
  DIALOG_FILTER_NEW_OPEN,
  DIALOG_FILTER_NEW_CLOSE,
  //FILTER - Delete Filter
  DIALOG_FILTER_DELETE_OPEN,
  DIALOG_FILTER_DELETE_CLOSE,
  // Generic Dialogs
  DIALOG_GENERIC_CONFIRM_OPEN,
  DIALOG_GENERIC_CONFIRM_CLOSE,

  DIALOG_GENERIC_OK,
  DIALOG_GENERIC_OK_CLOSE,
  DIALOG_GENERIC_OK_CANCEL,

  // Restart / Login Dialogs
  DIALOG_RECONNECT_CONFIRM,
  DIALOG_RESTART_CONFIRM,

  // ORDER ENTRY - Close order entry
  /* 	DIALOG_ORDER_ENTRY_CONFIRM_ABORT_OPEN,
	DIALOG_ORDER_ENTRY_CONFIRM_ABORT_CLOSE,
	DIALOG_ORDER_ENTRY_CONFIRM_ABORT_CLOSE_INTERNAL,
	// MODIFY - Close modification
	DIALOG_MODIFY_CONFIRM_ABORT_OPEN,
	DIALOG_MODIFY_CONFIRM_ABORT_CLOSE,
	DIALOG_MODIFY_CONFIRM_ABORT_CLOSE_INTERNAL
 */
  // Detail fill fail dialog
  DIALOG_ORDER_FILL_FAIL,

  //Save public profile
  DIALOG_PUBLIC_PROFILE_SAVE,

  //Switch profile
  DIALOG_SWITCH_PROFILE,

  // Ops Intervention
  // DIALOG_OPS_INT_CONFIRM_CANCEL
  // is a DIALOG_GENERIC_CONFIRM_OPEN with a payload]
  DIALOG_OPS_INT_CONFIRM_CLEAR,

  // Dealer Intervention - Fwd Roll Price
  DIALOG_FWD_ROLL_SAVE_ABORT_OPEN,
  DIALOG_FWD_ROLL_SAVE_ABORT_CLOSE,

  // Settings - Change Password
  DIALOG_CHANGE_PASSWORD_OPEN,
  DIALOG_CHANGE_PASSWORD_CLOSE,

  AUTO_HEDGE_STATUS_CHANGE,
  DIALOG_GENERIC_WARN_OPEN,
}
